import { usePathname } from 'next/navigation';
import { useState } from 'react';

import { InitialSearchInput } from '@/components/static';
import { HERO_SECTION_SEARCH_INPUT_ID } from '@/constant/common';
import { STATIC_PAGES_PATH_NAMES } from '@/constant/routes';
import { useAppNavigationCtx } from '@/hooks/ctx';
import { useObserver } from '@/hooks/useObserver';
import { equals, isNil } from '@/utils/common';
import { isClientSide } from '@/utils/next';

import s from './styles.module.scss';

export function HeaderSERPInput() {
  const pathname = usePathname();
  const [isVisibleHeroSection, setIsVisibleHeroSection] = useState<boolean | null>(null);
  const { activeAppNavigationItemByRoute } = useAppNavigationCtx();
  const isIncorrectPage = Boolean(activeAppNavigationItemByRoute) || equals(pathname, STATIC_PAGES_PATH_NAMES.serp);

  const shouldRenderSearch = !isIncorrectPage || (!isVisibleHeroSection && !isNil(isVisibleHeroSection));

  useObserver({
    observableElements: isClientSide()
      ? document.querySelectorAll(`[data-test-id="${HERO_SECTION_SEARCH_INPUT_ID}"]`)
      : ([] as unknown as NodeListOf<Element>),
    observerConfig: { threshold: 1 },
    onObserve: entry => {
      setIsVisibleHeroSection(entry.isIntersecting);
    },
  });

  if (shouldRenderSearch) return <InitialSearchInput className={s.initial_search_input} placeholder='Поиск' />;

  return null;
}
